import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { restaurantManagerAPI } from '../../services/api';

// Restaurant Manager (multi-outlet) login. Email + password (admin-provisioned).
// On success we store the manager token and go to the outlet picker.
function RestaurantManagerLogin() {
  const navigate = useNavigate();
  const [form, setForm] = useState({ email: '', password: '' });
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setError('');
    setLoading(true);
    try {
      const res = await restaurantManagerAPI.login({ email: form.email.trim(), password: form.password });
      const { token, refreshToken } = res.data.data;
      localStorage.setItem('token', token);
      localStorage.setItem('manager_token', token);
      if (refreshToken) localStorage.setItem('refreshToken', refreshToken);
      localStorage.removeItem('managing_restaurant');
      window.location.href = '/restaurant-manager/select';
    } catch (err) {
      setError(err.response?.data?.message || 'Login failed');
      setLoading(false);
    }
  };

  return (
    <div style={{ minHeight: '100vh', display: 'flex', alignItems: 'center', justifyContent: 'center', background: 'linear-gradient(135deg,#FF6961 0%,#FF8A80 100%)', padding: 16 }}>
      <div style={{ width: '100%', maxWidth: 400, background: 'white', borderRadius: 16, padding: 32, boxShadow: '0 20px 50px rgba(0,0,0,0.2)' }}>
        <div style={{ textAlign: 'center', marginBottom: 24 }}>
          <div style={{ fontSize: 40 }}>🏬</div>
          <h2 style={{ margin: '8px 0 4px', color: '#0F172A' }}>Restaurant Manager</h2>
          <p style={{ color: '#64748B', fontSize: 14, margin: 0 }}>Manage your outlets from one login</p>
        </div>
        <form onSubmit={submit}>
          <label style={{ fontSize: 13, fontWeight: 600, color: '#374151' }}>Email</label>
          <input type="email" required value={form.email} onChange={(e) => setForm({ ...form, email: e.target.value })}
            style={{ width: '100%', padding: '12px', margin: '6px 0 16px', border: '1px solid #E2E8F0', borderRadius: 10, fontSize: 14, boxSizing: 'border-box' }} placeholder="you@example.com" />
          <label style={{ fontSize: 13, fontWeight: 600, color: '#374151' }}>Password</label>
          <input type="password" required value={form.password} onChange={(e) => setForm({ ...form, password: e.target.value })}
            style={{ width: '100%', padding: '12px', margin: '6px 0 16px', border: '1px solid #E2E8F0', borderRadius: 10, fontSize: 14, boxSizing: 'border-box' }} placeholder="••••••••" />
          {error && <div style={{ color: '#DC2626', fontSize: 13, marginBottom: 12 }}>{error}</div>}
          <button type="submit" disabled={loading}
            style={{ width: '100%', padding: 14, border: 'none', borderRadius: 10, background: '#FF6961', color: 'white', fontSize: 15, fontWeight: 700, cursor: loading ? 'not-allowed' : 'pointer', opacity: loading ? 0.7 : 1 }}>
            {loading ? 'Signing in…' : 'Sign In'}
          </button>
        </form>
        <div style={{ textAlign: 'center', marginTop: 16 }}>
          <button onClick={() => navigate('/login')} style={{ background: 'none', border: 'none', color: '#64748B', fontSize: 13, cursor: 'pointer' }}>← Back to main login</button>
        </div>
      </div>
    </div>
  );
}

export default RestaurantManagerLogin;
